module.exports = __webpack_public_path__ + "img/logo.a3e76cd2.png";